/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ra_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Higher is easier. 90–100 is very easy (5th grade), 60–70 is plain English for most adults, and below 30 is very difficult (college level). Aim for 60+ for a general audience.`)
};

const es_ra_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más alto es más fácil. 90–100 es muy fácil (quinto grado), 60–70 es inglés simple para la mayoría de los adultos, y por debajo de 30 es muy difícil (nivel universitario). Apunta a 60+ para una audiencia general.`)
};

const de_ra_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höher bedeutet leichter. 90–100 ist sehr leicht (5. Klasse), 60–70 entspricht einfachem Englisch für die meisten Erwachsenen, und unter 30 ist sehr schwer (Hochschulniveau). Für ein allgemeines Publikum sollten Sie 60 oder mehr anstreben.`)
};

const nl_ra_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoger is gemakkelijker. 90–100 is erg gemakkelijk (5e klasse), 60–70 is duidelijk Engels voor de meeste volwassenen, en onder de 30 is erg moeilijk (universiteitsniveau). Streven naar 60+ voor een algemeen publiek.`)
};

const fr_ra_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus c'est haut, plus c'est facile. 90–100 c'est très facile (5e année), 60–70 c'est l'anglais clair pour la plupart des adultes, et au-dessous de 30 c'est très difficile (niveau universitaire). Visez 60+ pour un public général.`)
};

const it_ra_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più alto è più facile. 90–100 è molto facile (5ª elementare), 60–70 è inglese semplice per la maggior parte degli adulti, e sotto 30 è molto difficile (livello universitario). Punta a 60+ per un pubblico generale.`)
};

const pt_br2_ra_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto maior, mais fácil. 90–100 é muito fácil (5ª série), 60–70 é português claro para a maioria dos adultos, e abaixo de 30 é muito difícil (nível universitário). Mire em 60+ para um público geral.`)
};

const pt_ra_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior é mais fácil. 90–100 é muito fácil (5º ano), 60–70 é inglês simples para a maioria dos adultos, e abaixo de 30 é muito difícil (nível universitário). Procure 60+ para um público geral.`)
};

const ja_ra_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高いほど読みやすくなります。90～100は非常に簡単（5年生）、60～70はほとんどの成人向けの平易な英語、30未満は非常に難しい（大学レベル）です。一般向けには60以上を目指してください。`)
};

const zh_ra_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分数越高越容易阅读。90–100 表示非常简单（五年级水平），60–70 是大多数成年人都能读懂的普通英语，低于 30 则表示非常困难（大学水平）。面向大众读者时，建议目标为 60 分以上。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ra_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ra_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ra_faq1_a", locale)
	if (locale === "en") return en_ra_faq1_a(inputs)
	if (locale === "es") return es_ra_faq1_a(inputs)
	if (locale === "de") return de_ra_faq1_a(inputs)
	if (locale === "nl") return nl_ra_faq1_a(inputs)
	if (locale === "fr") return fr_ra_faq1_a(inputs)
	if (locale === "it") return it_ra_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_ra_faq1_a(inputs)
	if (locale === "pt") return pt_ra_faq1_a(inputs)
	if (locale === "ja") return ja_ra_faq1_a(inputs)
	return zh_ra_faq1_a(inputs)
};